var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-content card-general" }, [
      _c("div", [
        _c("div", {
          staticClass: "skeleton-box mb-10px",
          staticStyle: { height: "100px" }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "skeleton-box",
          staticStyle: { height: "200px" }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("div", {
          staticClass: "skeleton-box mb-10px",
          staticStyle: { height: "80px" }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "skeleton-box",
          staticStyle: { height: "120px" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d67557cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d67557cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/application-manager/detail/app-tabs/partials/loading/skeletonGeneralTab.vue
// module id = null
// module chunks = 